// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.notification-list[data-v-f5bb8ca0] {\n    max-height: 400px;\n    overflow-y: auto;\n}\n.unread-notification[data-v-f5bb8ca0] {\n    background-color: rgba(var(--v-primary-base), 0.04);\n}\n.unread-notification[data-v-f5bb8ca0]:hover {\n    background-color: rgba(var(--v-primary-base), 0.08);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
